import apiClient from './apiClient';

/**
 * Creates a new job drive
 * @param {Object} jobData - The job details including trades and colleges
 * @returns {Promise<Object>} The API response
 */
export const createJob = async (jobData) => {
    try {
        const response = await apiClient.post('/jobs', jobData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * Fetches the active list of trades
 * @param {string} search - Optional search term
 * @returns {Promise<Object>} The API response with trade list
 */
export const getTrades = async (search = '') => {
    try {
        const response = await apiClient.get(`/trades/active-list${search ? `?search=${search}` : ''}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * Fetches applications for the current company's job drives
 * @param {Object} params - Query parameters for filtering (jobId, studentId, status)
 * @returns {Promise<Object>} The API response with applications
 */
export const getApplications = async (params = {}) => {
    try {
        const response = await apiClient.get('/job-applications', { params });
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * Updates the status of an application
 * @param {string} applicationId - ID of the application
 * @param {Object} data - Contains new status and optional rejection reason
 * @returns {Promise<Object>} The API response
 */
export const updateApplicationStatus = async (applicationId, data) => {
    try {
        const response = await apiClient.patch(`/job-applications/${applicationId}/status`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};
/**
 * Fetches jobs for the current company
 * @param {Object} params - Filtering parameters
 * @returns {Promise<Object>} The API response with jobs
 */
export const getJobs = async (params = {}) => {
    try {
        const response = await apiClient.get('/jobs', { params });
        return response.data;
    } catch (error) {
        throw error;
    }
};
